<button (click)="goBack()" class="btn btn-primary back-btn">
  <i class="fas fa-arrow-left"></i> {{'HEADER.BACK_BTN' | translate}}
</button>
